import { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

/**
 * Управление состоянием мобильного нав-Drawer.
 * Закрывается при смене пути (чтобы не висел открытым после перехода).
 */
export const useMobileNav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();

  /**
   * Открыть Drawer
   */
  const open = () => setIsOpen(true);

  /**
   * Закрыть Drawer
   */
  const close = () => setIsOpen(false);

  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  return { isOpen, open, close };
};
